import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getBackupAdvertiser = createSelector(
  (state: Store) => state.dealManagement.backupFormData.commonDeal.advertiser,
  (advertiser) => advertiser,
);

export const getBackupBrand = createSelector(
  (state: Store) => state.dealManagement.backupFormData.commonDeal.brand,
  (brand) => brand,
);

export const getBackupProductCategory = createSelector(
  (state: Store) => state.dealManagement.backupFormData.commonDeal.productCategory,
  (productCategory) => productCategory,
);

export const getBackupAgency = createSelector(
  (state: Store) => state.dealManagement.backupFormData.commonDeal.agency,
  (agency) => agency,
);

export const getBackupSpecialist = createSelector(
  (state: Store) => state.dealManagement.backupFormData.commonDeal.specialist,
  (specialist) => specialist,
);
